export function paddingToClass(padding: string): string {
  switch (padding) {
    case 'none':
      return 'py-0';
    case 'sm':
      return 'py-8';
    case 'md':
      return 'py-16';
    case 'lg':
      return 'py-24';
    case 'xl':
      return 'py-32';
    default:
      return 'py-16';
  }
}

export function contentWidthToClass(width: string): string {
  switch (width) {
    case 'narrow':
      return 'max-w-2xl';
    case 'wide':
      return 'max-w-7xl';
    case 'full':
      return 'max-w-full';
    default:
      return 'max-w-5xl';
  }
}
